import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CampaignService, CRMService, UserService} from '../_services';
import {CrudPagedListComponent} from '../_directives';
import {Campaign, CampaignStatus, CRM, CRMStatus, User} from '../_models';
import {Observable} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {NgxSmartModalService} from 'ngx-smart-modal';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './crm.component.html'
})
export class CRMComponent extends CrudPagedListComponent implements OnInit {
  crms$: Observable<CRM[]> = this.data$;
  selectedCRM: CRM;
  user: User;

  private isSyncing: {} = {};

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected crmService: CRMService,
    protected alertService: AlertService,
    private modalService: NgxSmartModalService,
    protected userService: UserService,
    protected campaignService: CampaignService,
  ) {
    super(router, location, route, crmService, alertService);
    this.objectName = 'Platform interface';
    this.title = 'My Platforms';
  }

  ngOnInit() {
    super.ngOnInit();
    this.userService.getCurrent()
      .subscribe((user: User) => {
        this.user = user;
      });
  }

  isBusySyncing(crm: CRM) {
    return (crm.id in this.isSyncing) && this.isSyncing[crm.id]
  }

  sync(crm: CRM) {
    this.isSyncing[crm.id] = true;
    this.crmService.sync(crm.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.isSyncing[crm.id] = false;
        },
        error => {
          this.handleSubmitError(error);
          this.isSyncing[crm.id] = false;
        });
  }

  copyOrder(crm: CRM) {
    this.selectedCRM = crm;
    this.modalService.getModal('crmCopyOrderDialog').open();
  }

  onCloseDialog() {
    this.selectedCRM = null;
  }

  viewMerchants(crm: CRM) {
    this.selectedCRM = crm;
    this.modalService.getModal('crmMerchantsDialog').open();
  }

  protected onDelete(id) {
    this.campaignService.refresh();
  }

  isDeleted(crm: CRM) {
    return crm.status === CRMStatus.Deleted;
  }

  isEnabled(crm: CRM) {
    return crm.status === CRMStatus.Enabled;
  }

  enable(crm: CRM, event) {
    let enable: boolean = event.target.checked;
    let action = enable ? 'enable' : 'disable';

    if (!this.isDeleted(crm) &&
      window.confirm('Are you sure you want to ' + action + ' ' + crm.name + ' CRM?')) {
      this.crmService.patch(crm.id, {status: enable ? CRMStatus.Enabled : CRMStatus.Disabled})
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            action = enable ? 'Enabled' : 'Disabled';
            this.alertService.success(action + ' ' + crm.name + ' CRM.');
          },
          error => {
            this.handleSubmitError(error);
            event.target.checked = !enable; //revert checkbox to previous state
          });
    }
    else {
      event.target.checked = !enable; //revert checkbox to previous state (should not get here but just in case)
    }
  }
}
